export default "__VITE_ASSET__pzcPpHVZ__"